module.exports = __webpack_public_path__ + "static/img/dapm-course02.5825799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/dapm-course02.png
// module id = YDyK
// module chunks = 2